import Vue from "vue";
import * as FilterFunctions from "./filterFunctions";

//城管审核状态
Vue.filter("govCharge", FilterFunctions.govCharge);
